import * as CONSTANTS from "../utils/constants/constants";
import axios from "axios";

const pendingBillingRequests = new Map<string, Promise<any>>();

class BillingService {
    static async billingSummary(access_token: string, organization_id: string, month: string): Promise<any> {
        const requestKey = `${organization_id}:${month}`;
        const pendingRequest = pendingBillingRequests.get(requestKey);
        if (pendingRequest) {
            return pendingRequest;
        }

        const url = CONSTANTS.HOST + "api/v1/rpm/billingsummary/";
        const request = axios
            .post(url, {
                organization_id: organization_id,
                month: month,
            }, {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            })
            .then((response) => response.data)
            .finally(() => {
                pendingBillingRequests.delete(requestKey);
            });

        pendingBillingRequests.set(requestKey, request);
        return request;
    }


}

export default BillingService;
